import { ElementRef } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i2 from "../../../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
const _c0 = () => ["popover"];
export class EsgInfoPopoverComponent {
    constructor(eltRef) {
        this.eltRef = eltRef;
        this.tooltipContent = '';
        this.tooltipContent = this.eltRef.nativeElement.getAttribute('tooltipContent');
    }
}
EsgInfoPopoverComponent.ɵfac = function EsgInfoPopoverComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || EsgInfoPopoverComponent)(i0.ɵɵdirectiveInject(i0.ElementRef)); };
EsgInfoPopoverComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: EsgInfoPopoverComponent, selectors: [["ycn-esg-info-popover"]], standalone: false, decls: 2, vars: 5, consts: [["ycnTooltip", "", 1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-esg-help", 3, "tooltipClasses", "tooltipHtml", "tooltipTitle"], ["ycnIcon", "", 3, "name"]], template: function EsgInfoPopoverComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(1, "svg", 1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("tooltipClasses", i0.ɵɵpureFunction0(4, _c0))("tooltipHtml", true)("tooltipTitle", ctx.tooltipContent);
        i0.ɵɵadvance();
        i0.ɵɵproperty("name", "icon-info");
    } }, dependencies: [i1.IconDirective, i2.TooltipDirective], encapsulation: 2 });
